import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  TranslationProvider,
  Loader,
} from '@resy/ui-kitchen';
import { getVenues } from '../../../../../ui-kitchen/src/api/api';
import { listVenuesTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import './ListVenues.scss';

const listVenuesPropTypes = {
  $rootScope: PropTypes.shape({
    metadata: PropTypes.shape({
      bodyClasses: PropTypes.string,
    }),
  }).isRequired,
  metadata: PropTypes.shape({
    bodyClasses: PropTypes.string,
  }).isRequired,
};

const ListVenues = ({ $rootScope, metadata }) => {
  const [venueList, setVenueList] = useState([]);
  let ignore = false;
  useEffect(() => {
    const fetchVenues = () => getVenues().then((data) => {
      const venues = listVenuesTransform(data);
      if (!ignore) { setVenueList(venues); }
    });
    $rootScope.metadata.bodyClasses = metadata.bodyClasses;
    fetchVenues();
    return () => { ignore = true; };
  }, []);

  const hasVenues = venueList.length > 0;
  return (
    <article className="container ListVenues">
      <TranslationProvider translationKey="list_venues_header">
        <h1>Check out all the great restaurants on Resy</h1>
      </TranslationProvider>
      {!hasVenues && <Loader />}
      {hasVenues && (
        <ul>
          {venueList.map((venue) => (
            <li key={venue.id}>
              <a className="venue" href={`cities/${venue.location.urlSlug}/venues/${venue.urlSlug}`}>{venue.name}</a>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};

ListVenues.propTypes = listVenuesPropTypes;

export { listVenuesPropTypes };
export default ListVenues;
